import React, {Component, CSSProperties} from 'react';
import PropTypes from 'prop-types';
import CardUserData from '../../components/CardUserData';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import { GetCTEstatus, GetPreregistrosN, GetPreregistrosNumero, GetPreregistrosCN, GetCTEstatusN, GetNoregistros, GetPreregistrosCNB, GetCTEstatusNB} from '../../../services/SecurityService';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import LoopRoundedIcon from '@material-ui/icons/LoopRounded';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import AdjustRoundedIcon from '@material-ui/icons/AdjustRounded';
import BallotRoundedIcon from '@material-ui/icons/BallotRounded';
import ClipLoader from "react-spinners/ClipLoader";




const styles = theme => ({
    mainContainer: {
        display: 'flex',
       

    }
});

let buttonsProfile = [
  {
    icono:<SaveRoundedIcon/>,
    nombre:"PREREGISTROS",
  
  color:'white',
  colorletra:'#495057',
  borderColor:'#027272',
  textTransform:'none',

  
  
},
{icono:<BallotRoundedIcon/>,nombre:"REGISTRADOS",colorletra:'#495057',borderColor:'#274178',color:"white",textTransform:"none"},
{icono:<AdjustRoundedIcon/>,nombre:"PENDIENTE",colorletra:'#495057',borderColor:'#606060',color:"white"},
{icono:<LoopRoundedIcon/>,nombre:"EN TRAMITE",colorletra:'#495057',borderColor:'#F3B122',color:"white"},
{icono:<LoopRoundedIcon/>,nombre:"EN FIRMAS",colorletra:'#495057',borderColor:'#606060',color:"white"},
{icono:<AdjustRoundedIcon/>,nombre:"POR ENTREGAR",colorletra:'#495057',borderColor:'#274178',color:"white"},
{icono:<CheckCircleRoundedIcon/>,nombre:"ENTREGADOS",colorletra:'#495057',borderColor:'#44AC34',color:"white"},
{icono:<NavigationIcon/>,nombre:"TODOS",colorletra:'#495057',borderColor:'#44AC34',color:"white"},



];

const buttonsProfileND = [
  {
    icono:<SaveRoundedIcon/>,
    nombre:"Registros",
  
  color:'white',
  colorletra:'#606060',
  borderColor:'#606060',

  
  
},
{icono:<LoopRoundedIcon/>,nombre:"Para Firmas",colorletra:'#606060',borderColor:'#606060',color:"white"},
{icono:<AdjustRoundedIcon/>,nombre:"No Registrados",colorletra:'#606060',borderColor:'#606060',color:"white"},

];

class SecurityProfile extends Component {

    constructor(props){
        super(props);

        this.handleButtonsEvents = this.handleButtonsEvents.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.stopEditing = this.stopEditing.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.startEditing = this.startEditing.bind(this);
        this.onOEP = this.onOEP.bind(this);
        this.onOT = this.onOT.bind(this);
        this.onR= this.onR.bind(this);
        this.onB= this.onB.bind(this);
        const {user} = props;
        this.state = {
            
            data: [{
                Usuario: user.userData.Usuario,
                Correo: user.userData.Correo,
                id_usuario: user.userData.IdUsuario, 
                iduser:user.userData.iduser, 
                tipo:user.userData.tipo,
                id_usuariou:user.userData.id_usuario
            }],
            titulo : '',
            userD : user,
            editIdx: -1,
            oficios:[],
            oficiosR : [],
            oficiosEP: [],
            oficiosTAA: [],
            oficiosNOR:[],
            respuestaP: [],
            respuestaN: [],
            respuestaS: [],
            oficiosLic:[],
            oficiosT:[],
            cancelado:'',
            todos:[],
            etiquetA: '',
            index:0,
            creg:0,
            cpro:0,
            cpos:0,
            cneg:0,
            csus:0,
            clic:0,

            ordAEP:0,
            ordAT:0,
            buscar:'',

            loadingT:false,
        };
    }

    componentDidMount(){

     
        console.log("el  usuario")
        console.log(this.state.userD)
       
        if(this.state.userD.userData.tipo==1){
          this.setState({index:0})
        }else{
          this.setState({index:1})

        }

        if(this.state.userD.userData.tipo==1){

          
          GetPreregistrosN().then(response => {
            //if(response=="")
    
            if(response!="No existen clientes en la BBDD."){
           
          this.setState({ 
            oficios: response,
            oficiosR:response,

          
          })
        }
          console.log("Aqui estan los oficios preRegistradosN")
          console.log(response)
        }).catch(err => console.log(err)); 

        /*
          GetPreregistrosNumero().then(response => {
          

            //if(response=="")
    
            if(!isNaN(response[0].total)){
             
              let resultado = Math.ceil(response[0].total / 6000);

              console.log("El resultado es:", resultado);

              let arr = [];
              let arr2 = [];
              let arr3 = [];
              let arr4 = [];
              let arr5 = [];
              let arr6 = [];
              let arr7 = [];
              let arr8 = [];

              let promises = Array.from({ length: resultado }).map((_, index) => {
                let promise1 = GetPreregistrosCN({ n: ((index) * 6000) })
                    .then(response => {
                        console.log("Iteración número:", index + 1);
                        console.log(response);
                        return response;
                    })
                    .catch(err => console.log(err)); 
            
                let promise2 = GetCTEstatusN({ estatus: 6, n: ((index) * 6000) })
                    .then(response => {
                        console.log("Iteración número:", index + 1);
                        console.log(response);
                        return response;
                    })
                    .catch(err => console.log(err)); 
            
                // Retornar las promesas para su manejo posterior
                return Promise.all([promise1, promise2]);
            });
            
            // Esperar a que todas las promesas se resuelvan
            Promise.all(promises)
                .then(results => {
                    // Manejar los resultados de cada llamada asíncrona
                    results.forEach((result, index) => {
                        arr7 = arr7.concat(result[0]); // Concatenar resultados de GetPreregistrosCN
                        arr6 = arr6.concat(result[1]); // Concatenar resultados de GetCTEstatusN
                    });
            
                    // Imprimir los arreglos finales
                    console.log('arreglo final GetPreregistrosCN:', arr7);
                    console.log('arreglo final GetCTEstatusN:', arr6);
            
                    // ACTUALIZAR el estado si es necesario
                    this.setState({
                        todos: arr7,
                        cancelado: arr6,
                        loadingT:false
                    });


                })
                .catch(err => {
                  this.setState({loadingT:false});

                });
     
            

            }
         
        }).catch(err => console.log(err));  
    */
    
        GetCTEstatus({estatus:1}).then(response => {
          //if(response=="")
    
          if(response!="No existen clientes en la BBDD."){
         
        this.setState({ 
      
          oficiosEP:response,
        
        })
      }
        console.log("Aqui estan los oficios Registrados")
        console.log(response)
      }).catch(err => console.log(err));  
    
      GetCTEstatus({estatus:2}).then(response => {
        //if(response=="")
    
        if(response!="No existen clientes en la BBDD."){
       
      this.setState({ 
       
        respuestaP:response,
      
      })
    }
      console.log("Aqui estan los oficios pendiente")
      console.log(response)
    }).catch(err => console.log(err));  
    
    GetCTEstatus({estatus:3}).then(response => {
      //if(response=="")
    
      if(response!="No existen clientes en la BBDD."){
     
    this.setState({ 
    
      respuestaN:response,
     
    })
    }
    console.log("Aqui estan los oficios en tramite")
    console.log(response)
    }).catch(err => console.log(err));  
    
    GetCTEstatus({estatus:4}).then(response => {
      //if(response=="")
    
      if(response!="No existen clientes en la BBDD."){
     
    this.setState({ 
     
      respuestaS:response,
      
    })
    }
    console.log("Aqui estan los oficios en firmas")
    console.log(response)
    }).catch(err => console.log(err));  
    
    GetCTEstatus({estatus:5}).then(response => {
      //if(response=="")
    
      if(response!="No existen clientes en la BBDD."){
     
    this.setState({ 
     
      oficiosLic:response,
    
    })
    }
    console.log("Aqui estan los oficios por entregar")
    console.log(response)
    }).catch(err => console.log(err));  
    
    
                  }else{

                    GetCTEstatus({estatus:4}).then(response => {
                      //if(response=="")
                    
                      if(response!="No existen clientes en la BBDD."){
                     
                    this.setState({ 
                      oficios: response,
                      respuestaS:response,
                      
                    })
                    }
                    console.log("Aqui estan los oficios en firmas")
                    console.log(response)
                    }).catch(err => console.log(err));  
              
                    GetNoregistros().then(response => {
                      //if(response=="")
              
                      if(response!="No existen clientes en la BBDD."){
                     
                    this.setState({ 
                      oficiosNOR: response,
                  
                    
                    })
                  }
                    console.log("Aqui estan los oficios preRegistradosN")
                    console.log(response)
                  }).catch(err => console.log(err)); 

             /*       
                    GetPreregistrosNumero().then(response => {
          
                      this.setState({loadingT:true})
                      //if(response=="")
              
                      if(!isNaN(response[0].total)){
                       
                        let resultado = Math.ceil(response[0].total / 6000);
              
                        console.log("El resultado es:", resultado);
              
                        let arr = [];
              
                       // Crear un array de promesas para todas las llamadas asíncronas
let promises = Array.from({ length: resultado }).map((_, index) => {
  return GetPreregistrosCN({ n: ((index) * 6000) })
      .then(response => {
          console.log("Iteración número:", index + 1);
          console.log(response);
          return response;
      })
      .catch(err => console.log(err)); 
});

// Esperar a que todas las promesas se resuelvan
Promise.all(promises)
  .then(results => {
      // Concatenar todos los resultados en un solo array
      let arr = results.reduce((accumulator, currentArray) => accumulator.concat(currentArray), []);

      // Filtrar el array para obtener solo los elementos con vinculado igual a 'S'
      let filteredArr = arr.filter(d => d.vinculado === 'S');

      // ACTUALIZAR el estado con los resultados filtrados
      this.setState({
          oficiosR: filteredArr
      });

      this.setState({loadingT:false})
  })
  .catch(err => this.setState({loadingT:false}));

                        
               
                      
              
                      }
                   
                  }).catch(err => console.log(err));  
              
              */
                
              
      
            
                  }

    

    }

    handleButtonsEvents(event, index){
        const {user} = this.props;

        if(this.state.userD.userData.tipo==1){
               
            switch(index){
                case 0:
                this.setState({
                   oficios : this.state.oficiosR,
                   titulo : 'Registro de Oficios',
                   etiquetA : AddIcon,
                   index:0
    
                });
                break;
                case 1:
                this.setState({
                    oficios : this.state.oficiosEP,
                    titulo : 'Oficios Turnados',
                    etiquetA : DeleteIcon ,
                    index:1
                });
                break;
                {/*case 2:
                this.setState({
                    oficios : this.state.oficiosTAA,
                    titulo : 'Oficios Turnados Recibidos',
                    etiquetA : NavigationIcon ,
                    index:2
                });
              break;*/}
                case 2:
                this.setState({
                    oficios : this.state.respuestaP,
                    titulo : 'Oficios Concluidos Positivos',
                    etiquetA : ArrowDownwardIcon ,
                    index:2
                });
                break;
                case 3:
                    this.setState({
                        oficios : this.state.respuestaN,
                        titulo : 'Oficios Concluidos Negativos',
                        etiquetA : ArrowDownwardIcon ,
                        index:3
                    });
                    break;
                    case 4:
                      this.setState({
                          oficios : this.state.respuestaS,
                          titulo : 'Oficios Para Inspección',
                          etiquetA : ArrowDownwardIcon ,
                          index:4
                      });
                      break;
                      case 5:
                      this.setState({
                          oficios : this.state.oficiosLic,
                          titulo : 'Oficios Licencia',
                          etiquetA : ArrowDownwardIcon ,
                          index:5
                      });
                      break;
                      case 6:
                       { this.setState({
                            oficios : this.state.cancelado,
                            titulo : 'Oficios Cancelado',
                            etiquetA : ArrowDownwardIcon ,
                            index:6
                        });
/*
                        if (this.state.cancelado.length === 0) {
                          GetPreregistrosNumero().then(response => {
          
                            this.setState({loadingT:true});
                            //if(response=="")
                    
                            if(!isNaN(response[0].total)){
                             
                              let resultado = Math.ceil(response[0].total / 6000);
                
                              console.log("El resultado es:", resultado);
                
                             
                              let arr6 = [];
                        
                          
                
                              let promises = Array.from({ length: resultado }).map((_, index) => {
                        
                            
                                let promise2 = GetCTEstatusN({ estatus: 6, n: ((index) * 6000) })
                                    .then(response => {
                                        console.log("Iteración número:", index + 1);
                                        console.log(response);
                                        return response;
                                    })
                                    .catch(err => console.log(err)); 
                            
                                // Retornar las promesas para su manejo posterior
                                return Promise.all([ promise2]);
                            });
                            
                            // Esperar a que todas las promesas se resuelvan
                            Promise.all(promises)
                                .then(results => {
                                    // Manejar los resultados de cada llamada asíncrona
                                    results.forEach((result, index) => {
                                   // Concatenar resultados de GetPreregistrosCN
                                        arr6 = arr6.concat(result[0]); // Concatenar resultados de GetCTEstatusN
                                    });
                            
                                    // Imprimir los arreglos finales
                     
                                    console.log('arreglo final GetCTEstatusN:', arr6);
                            
                                    // ACTUALIZAR el estado si es necesario
                                    this.setState({
                                        cancelado: arr6,
                                        loadingT:false
                                    });
                                    this.setState({
                                      oficios : arr6,
                                      titulo : 'Oficios Cancelado',
                                      etiquetA : ArrowDownwardIcon ,
                                      index:6
                                  });
                
                                })
                                .catch(err => {
                                  this.setState({loadingT:false});
                
                                });
                     
                            
                
                            }
                         
                        }).catch(err => console.log(err));  
                      }
                        */

                      GetCTEstatusNB({dato:this.state.buscar,estatus:6}).then(response => {
                        //if(response=="")
                
                        if(response!="No existen clientes en la BBDD."){
                       
                      this.setState({ 
                        cancelado: response,
                        oficios:response
                    
                      
                      })
        
                   
                    }else{
                      this.setState({ 
                        cancelado: [],
                    
                      
                      })
        
                    }
                      console.log(response)
                    }).catch(err => console.log(err)); 
                      
                      }
                        break;
                        case 7:
                       { this.setState({
                            oficios : this.state.todos,
                            titulo : 'Oficios Cancelado',
                            etiquetA : ArrowDownwardIcon ,
                            index:7
                        });

                        GetPreregistrosCNB({dato:this.state.buscar}).then(response => {
                          //if(response=="")
                  
                          if(response!="No existen clientes en la BBDD."){
                         
                        this.setState({ 
                          todos: response,
                          oficios:response
                        
                        })
          
                        
                      }else{
                        this.setState({ 
                          todos: [],
                      
                        
                        })
          
                      }
                        console.log(response)
                      }).catch(err => console.log(err)); 

                        /*
                        if (this.state.todos.length === 0) {
                          GetPreregistrosNumero().then(response => {
          
                            this.setState({loadingT:true});
                            //if(response=="")
                    
                            if(!isNaN(response[0].total)){
                             
                              let resultado = Math.ceil(response[0].total / 6000);
                
                              console.log("El resultado es:", resultado);
                
                             
                              let arr7 = [];
                        
                
                              let promises = Array.from({ length: resultado }).map((_, index) => {
                                let promise1 = GetPreregistrosCN({ n: ((index) * 6000) })
                                    .then(response => {
                                        console.log("Iteración número:", index + 1);
                                        console.log(response);
                                        return response;
                                    })
                                    .catch(err => console.log(err)); 
                            
                                
                            
                                // Retornar las promesas para su manejo posterior
                                return Promise.all([promise1]);
                            });
                            
                            // Esperar a que todas las promesas se resuelvan
                            Promise.all(promises)
                                .then(results => {
                                    // Manejar los resultados de cada llamada asíncrona
                                    results.forEach((result, index) => {
                                        arr7 = arr7.concat(result[0]); // Concatenar resultados de GetPreregistrosCN
                                 // Concatenar resultados de GetCTEstatusN
                                    });
                            
                                    // Imprimir los arreglos finales
                                    console.log('arreglo final GetPreregistrosCN:', arr7);
                 
                            
                                    // ACTUALIZAR el estado si es necesario
                                    this.setState({
                                        todos: arr7,
                                        loadingT:false
                                    });
                                    this.setState({
                                      oficios : arr7,
                                      titulo : 'Oficios Cancelado',
                                      etiquetA : ArrowDownwardIcon ,
                                      index:7
                                  });
                
                                })
                                .catch(err => {
                                  this.setState({loadingT:false});
                
                                });
                     
                            
                
                            }
                         
                        }).catch(err => console.log(err)); 
                      }
*/
                       
                      
                      
                      }
                        break;
                default: 
                break;

          }
          
          
        }else{
          switch(index){
            case 0:{

            this.setState({
               oficios : this.state.oficiosR,
               titulo : 'Registro de Oficios',
               etiquetA : AddIcon,
               index:0

            });
          

              GetPreregistrosCNB({dato:this.state.buscar}).then(response => {
                //if(response=="")
        
                if(response!="No existen clientes en la BBDD."){
               
              this.setState({ 
                oficiosR: response,
            
              
              })

              if(this.state.index==0){
                this.setState({ 
                  oficios: response,
                })
              }
            }
              console.log("Aqui estan los oficios preRegistradosN")
              console.log(response)
            }).catch(err => console.log(err)); 

              /*
              GetPreregistrosNumero().then(response => {
          
                this.setState({loadingT:true})
                //if(response=="")
        
                if(!isNaN(response[0].total)){
                 
                  let resultado = Math.ceil(response[0].total / 6000);
        
                  console.log("El resultado es:", resultado);
        
                  let arr = [];
        
                 // Crear un array de promesas para todas las llamadas asíncronas
let promises = Array.from({ length: resultado }).map((_, index) => {
return GetPreregistrosCN({ n: ((index) * 6000) })
.then(response => {
    console.log("Iteración número:", index + 1);
    console.log(response);
    return response;
})
.catch(err => console.log(err)); 
});

// Esperar a que todas las promesas se resuelvan
Promise.all(promises)
.then(results => {
// Concatenar todos los resultados en un solo array
let arr = results.reduce((accumulator, currentArray) => accumulator.concat(currentArray), []);

// Filtrar el array para obtener solo los elementos con vinculado igual a 'S'
let filteredArr = arr.filter(d => d.vinculado === 'S');

// ACTUALIZAR el estado con los resultados filtrados
this.setState({
    oficiosR: filteredArr
});

this.setState({
  oficios : this.state.oficiosR,
  titulo : 'Registro de Oficios',
  etiquetA : AddIcon,
  index:0

});

this.setState({loadingT:false})
})
.catch(err => this.setState({loadingT:false}));

                  
         
                
        
                }
             
            }).catch(err => console.log(err));  
        */

          
          
          
          
          
          }
            break;
                case 1:
                  this.setState({
                      oficios : this.state.respuestaS,
                      titulo : 'Oficios Para Inspección',
                      etiquetA : ArrowDownwardIcon ,
                      index:1
                  });
                  break;
                  case 2:
                  this.setState({
                      oficios : this.state.oficiosNOR,
                      titulo : 'Oficios Para Inspección',
                      etiquetA : ArrowDownwardIcon ,
                      index:2
                  });
                  break;
         
            default: 
            break;

      }

        }
       
    
}


    handleRemove(i){
        this.setState(state => ({
          data: state.data.filter((row, j) => j !== i)
        }));
    };
    
    startEditing(i){
        this.setState({ editIdx: i });
    };
    
    stopEditing(i){
        this.setState({ editIdx: -1 });
        //PostTypeCompetences(this.state.data[i]);
    };
    
    onR(){
      if(this.state.userD.userData.tipo==1){


        GetPreregistrosN().then(response => {
          //if(response=="")
  
          if(response!="No existen clientes en la BBDD."){
         
        this.setState({ 
          //oficios: response,
          oficiosR:response,
        
  
  
  
        
        })
  
        if(this.state.index==0){
          this.setState({ 
            oficios: response,
          })
        }
   
      }else{
        this.setState({oficiosR:[]});
        if(this.state.index==0){
          this.setState({ 
            oficios: [],
          })
        }
      }
        console.log("Aqui estan los oficios preRegistradosN")
        console.log(response)
      }).catch(err => console.log(err));  
  
/*
      GetPreregistrosNumero().then(response => {
          

        //if(response=="")

        if(!isNaN(response[0].total)){
          this.setState({loadingT:true})
          let resultado = Math.ceil(response[0].total / 6000);

          console.log("El resultado es:", resultado);

          let arr = [];
              let arr2 = [];
              let arr3 = [];
              let arr4 = [];
              let arr5 = [];
              let arr6 = [];
              let arr7 = [];
              let arr8 = [];

              let promises1 = Array.from({ length: resultado }).map((_, index) => {
                return GetPreregistrosCN({ n: ((index) * 6000) })
                    .then(response => {
                        console.log("Iteración número:", index + 1);
                        console.log(response);
                        return response;
                    })
                    .catch(err => console.log(err)); 
            });
            
            let promises2 = Array.from({ length: resultado }).map((_, index) => {
                return GetCTEstatusN({ estatus: 6, n: ((index) * 6000) })
                    .then(response => {
                        console.log("Iteración número:", index + 1);
                        console.log(response);
                        return response;
                    })
                    .catch(err => console.log(err)); 
            });
            
            Promise.all([Promise.all(promises1), Promise.all(promises2)])
                .then(results => {
                    let arr7 = results[0].reduce((accumulator, currentArray) => accumulator.concat(currentArray), []);
                    let arr6 = results[1].reduce((accumulator, currentArray) => accumulator.concat(currentArray), []);
            
                    console.log('Arreglo final 1:', arr7);
                    console.log('Arreglo final 2:', arr6);
            
                    this.setState({
                        todos: arr7,
                        cancelado: arr6
                    });
            
                    if (this.state.index === 7) {
                        this.setState({ 
                            oficios: arr7
                        });
                    }

                    if (this.state.index === 6) {
                      this.setState({ 
                          oficios: arr6
                      });
                  }

                  this.setState({loadingT:false})
                })
                .catch(err => this.setState({loadingT:false}));
            
          
 
        

        }
     
    }).catch(err => console.log(err));  
*/

  
      GetCTEstatus({estatus:1}).then(response => {
        //if(response=="")
  
        if(response!="No existen clientes en la BBDD."){
       
      this.setState({ 
    
        oficiosEP:response,
      
      })
      if(this.state.index==1){
        this.setState({ 
          oficios: response,
        })
      }
    }else{
      this.setState({oficiosEP:[]});
      if(this.state.index==1){
        this.setState({ 
          oficios: [],
        })
      }
    }
      console.log("Aqui estan los oficios Registrados")
      console.log(response)
    }).catch(err => console.log(err));  
  
    GetCTEstatus({estatus:2}).then(response => {
      //if(response=="")
  
      if(response!="No existen clientes en la BBDD."){
     
    this.setState({ 
     
      respuestaP:response,
    
    })
  
    if(this.state.index==2){
      this.setState({ 
        oficios: response,
      })
    }
  }else{
    this.setState({respuestaP:[]});
    if(this.state.index==2){
      this.setState({ 
        oficios: [],
      })
    }
  }
    console.log("Aqui estan los oficios pendiente")
    console.log(response)
  }).catch(err => console.log(err));  
  
  GetCTEstatus({estatus:3}).then(response => {
    //if(response=="")
  
    if(response!="No existen clientes en la BBDD."){
   
  this.setState({ 
  
    respuestaN:response,
   
  })
  if(this.state.index==3){
    this.setState({ 
      oficios: response,
    })
  }
  }else{
    this.setState({respuestaN:[]});
    if(this.state.index==3){
      this.setState({ 
        oficios: [],
      })
    }
  }
  console.log("Aqui estan los oficios en tramite")
  console.log(response)
  }).catch(err => console.log(err));  
  
  GetCTEstatus({estatus:4}).then(response => {
    //if(response=="")
  
    if(response!="No existen clientes en la BBDD."){
   
  this.setState({ 
   
    respuestaS:response,
    
  })
  if(this.state.index==4){
    this.setState({ 
      oficios: response,
    })
  }
  }else{
    this.setState({respuestaS:[]});
    if(this.state.index==4){
      this.setState({ 
        oficios: [],
      })
    }
  }
  console.log("Aqui estan los oficios en firmas")
  console.log(response)
  }).catch(err => console.log(err));  
  
  GetCTEstatus({estatus:5}).then(response => {
    //if(response=="")
  
    if(response!="No existen clientes en la BBDD."){
   
  this.setState({ 
   
    oficiosLic:response,
  
  })
  if(this.state.index==5){
    this.setState({ 
      oficios: response,
    })
  }
  }else{
    this.setState({oficiosLic:[]});
    if(this.state.index==5){
      this.setState({ 
        oficios: [],
      })
    }
  }
  console.log("Aqui estan los oficios por entregar")
  console.log(response)
  }).catch(err => console.log(err));  
  
 
                }else{
/*
                  GetPreregistrosNumero().then(response => {
                   

                    //if(response=="")
            
                    if(!isNaN(response[0].total)){
                      this.setState({loadingT:true})
                      let resultado = Math.ceil(response[0].total / 6000);
            
                      console.log("El resultado es:", resultado);
            
                      let arr = [];
            
                      let promises = Array.from({ length: resultado }).map((_, index) => {
                        return GetPreregistrosCN({ n: ((index) * 6000) })
                            .then(response => {
                                console.log("Iteración número:", index + 1);
                                console.log(response);
                                return response;
                            })
                            .catch(err => console.log(err)); 
                    });
                    
                    Promise.all(promises)
                        .then(results => {
                            let arr = results.reduce((accumulator, currentArray) => accumulator.concat(currentArray), []);
                    
                            console.log('Arreglo final:', arr);
                    
                            this.setState({
                                oficiosR: arr.filter(d => d.vinculado == 'S')
                            });
                    
                            if (this.state.index === 0) {
                                this.setState({ 
                                    oficios: arr.filter(d => d.vinculado == 'S')
                                });
                            }

                            this.setState({loadingT:false})
                        })
                        .catch(err => this.setState({loadingT:false}));
                    
                      
             
                    
            
                    }
                 
                }).catch(err => console.log(err));  
 */

                GetPreregistrosCNB({dato:this.state.buscar}).then(response => {
                  //if(response=="")
          
                  if(response!="No existen clientes en la BBDD."){
                 
                this.setState({ 
                  oficiosR: response,
                 
              
                
                })
  
                if(this.state.index==0){
                  this.setState({ 
                    oficios: response,
                  })
                }
              }else{
                this.setState({oficiosR:[]});
                if(this.state.index==0){
                  this.setState({ 
                    oficios: [],
                  })
                }
              }
                console.log("Aqui estan los oficios preRegistradosN")
                console.log(response)
              }).catch(err => console.log(err)); 

                GetNoregistros().then(response => {
                  //if(response=="")
          
                  if(response!="No existen clientes en la BBDD."){
                 
                this.setState({ 
                  oficiosNOR: response,
              
                
                })

                if(this.state.index==2){
                  this.setState({ 
                    oficios: response,
                  })
                }
              }else{
                this.setState({oficiosNOR:[]});
                if(this.state.index==2){
                  this.setState({ 
                    oficios: [],
                  })
                }
              }
                console.log("Aqui estan los oficios preRegistradosN")
                console.log(response)
              }).catch(err => console.log(err)); 
            
            
            
            GetCTEstatus({estatus:4}).then(response => {
              //if(response=="")
            
              if(response!="No existen clientes en la BBDD."){
             
            this.setState({ 
             
              respuestaS:response,
              
            })
            if(this.state.index==1){
              this.setState({ 
                oficios: response,
              })
            }
            }else{
              this.setState({respuestaS:[]});
              if(this.state.index==1){
                this.setState({ 
                  oficios: [],
                })
              }
            }
            console.log("Aqui estan los oficios en firmas")
            console.log(response)
            }).catch(err => console.log(err));  
            
          
                }
   

    }
    handleChange(e, name, i){
        const { value } = e.target;
        this.setState(state => ({
          data: state.data.map(
            (row, j) => (j === i ? { ...row, [name]: value } : row)
          ),
        }));
      };

      onOEP(i){

        console.log("AQUI AR ORIGINAL");
        console.log(this.state.oficiosEP);
if(i==0){
this.setState({
  oficiosEP:this.state.oficiosEP.sort((a,b)=>a.id_oficio-b.id_oficio)
})
}else if(i==1){
  this.setState({
    oficiosEP:this.state.oficiosEP.sort((a,b)=>b.id_oficio-a.id_oficio)
  })
}

console.log("AQUI AR ORDENADO");
console.log(this.state.oficiosEP);
}

onOT(i){
  if(i==0){
  this.setState({
    oficiosT:this.state.oficiosT.sort((a,b)=>a.id_oficio-b.id_oficio)
  })
  }else if(i==1){
    this.setState({
      oficiosT:this.state.oficiosT.sort((a,b)=>b.id_oficio-a.id_oficio)
    })
  }

      }

      onB(i){
 
        this.setState({
          buscar:i
        });

        if(this.state.userD.userData.tipo!=1){
        GetPreregistrosCNB({dato:i}).then(response => {
          //if(response=="")
  
          if(response!="No existen clientes en la BBDD."){
         
        this.setState({ 
          oficiosR: response,
         
      
        
        })

        if(this.state.index==0){
          this.setState({ 
            oficios: response,
          })
        }
      }
        console.log("Aqui estan los oficios preRegistradosN")
        console.log(response)
      }).catch(err => console.log(err)); 
    }else{
        if(this.state.index==6){
          GetCTEstatusNB({dato:i,estatus:6}).then(response => {
            //if(response=="")
    
            if(response!="No existen clientes en la BBDD."){
           
          this.setState({ 
            cancelado: response,
            oficios:response
        
          
          })

       
        }else{
          this.setState({ 
            cancelado: [],
        
          
          })

        }
          console.log(response)
        }).catch(err => console.log(err)); 
        }else if(this.state.index==7){
          GetPreregistrosCNB({dato:i}).then(response => {
            //if(response=="")
    
            if(response!="No existen clientes en la BBDD."){
           
          this.setState({ 
            todos: response,
            oficios:response
           
        
          
          })
  
          
        }else{
          this.setState({ 
            todos: [],
        
          
          })

        }
          
          console.log(response)
        }).catch(err => console.log(err)); 
        }


    }
            }

    render(){
        const {classes} = this.props;
let botones;
     

       if(this.state.userD.userData.tipo==1){
botones=buttonsProfile
       }else{
           botones=buttonsProfileND 
    }
           
        return(
        <div className={classes.mainContainer}>
            <div style={{position:'absolute',zIndex:1000000,right:'50%',top:'50%'}}><center>
            <ClipLoader
        color={'black'}
        loading={this.state.loadingT}
      
        size={50}
        aria-label="Loading Spinner"
        data-testid="loader"
      /></center></div>

            <CardUserData tableHeader={this.state.header}
            buttons={botones}     
            onClick={this.handleButtonsEvents}       
              tableData={this.state.data}
              oficiosR={this.state.oficios}
              oficiosEP={this.state.oficiosEP}
              etiqueta={this.state.titulo}
          //    etiquetA={this.state.etiquetA}
          indice={this.state.index}
              usuario={this.state.data[0].id_usuario}
              iduser={this.state.data[0].iduser}
              handleButtonsEvents={this.handleButtonsEvents}
              handleRemove={this.handleRemove}
              stopEditing={this.stopEditing}
              handleChange={this.handleChange}
              startEditing={this.startEditing}
              onOEP={this.onOEP}
              onOT={this.onOT}
              onR={this.onR}
              onB={this.onB}
              tipo={this.state.data[0].tipo}
              id_usuario={this.state.data[0].id_usuariou}
              editIdx={this.state.oficios} />
        </div>
        );
    }
}



SecurityProfile.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
    return {
        user: state.security
    };
};

export default connect(mapStateToProps)(withStyles(styles)(SecurityProfile));